module.exports = __webpack_public_path__ + "static/media/viviendas.c6d54eed.webp";